export const CAIP_NAMESPACE = 'eip155';
export const CAIP_ETHEREUM_CHAIN_ID = '1';
